// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"522":"d28ad9b0","651":"00058f20"}[chunkId] + ".chunk.js";
};